// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldTimeOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldTimeOutlined";
import AntdIcon from '../components/AntdIcon';

var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldTimeOutlinedSvg
  }));
};

FieldTimeOutlined.displayName = 'FieldTimeOutlined';
export default React.forwardRef(FieldTimeOutlined);